document.addEventListener('DOMContentLoaded', function(){
   const CLIENTS = [
    { name: "A", lastName: "Gómez" },
    { name: "B", lastName: "Martínez" },
    { name: "C", lastName: "Sánchez" },
    { name: "D", lastName: "López" },
    { name: "E", lastName: "Hernández" },
    { name: "F", lastName: "Pérez" },
    { name: "G", lastName: "Rodríguez" },
    { name: "H", lastName: "García" },
    { name: "I", lastName: "Fernández" },
    { name: "J", lastName: "Díaz" },
    { name: "K", lastName: "Moreno" },
    { name: "L", lastName: "Muñoz" },
    { name: "M", lastName: "Jiménez" },
    { name: "N", lastName: "Romero" },
    { name: "O", lastName: "Ruiz" },
    { name: "P", lastName: "Navarro" },
    { name: "Q", lastName: "Ortega" },
    { name: "R", lastName: "Gutiérrez" },
    { name: "S", lastName: "Serrano" },
    { name: "T", lastName: "Vega" },
    { name: "U", lastName: "López" },
    { name: "V", lastName: "Molina" },
    { name: "W", lastName: "Flores" },
    { name: "X", lastName: "Ramos" },
    { name: "Y", lastName: "Martín" },
    { name: "Z", lastName: "Vázquez" },
];


    let intervalCustomer;
    const DATA_TIME = 6000;

    const sortArray = (array = []) => {
        return array.sort(() => {
            return Math.random() - 0.5;
        }).splice(0, 5)
    }


    intervalCustomer = setInterval(() => {
        const getActivesCustomer = document.querySelectorAll('.purchase-customer.active');

        getActivesCustomer.forEach(customer => {
            customer.classList.remove('active');
        });

        const cardsProducts = sortArray([...document.querySelectorAll('#product-grid .grid__item')])

        cardsProducts.forEach(product => {
            const getClientRandom = CLIENTS[Math.floor(Math.random() * CLIENTS.length)];
            const wrapperCustomer = product.querySelector('.purchase-customer');

            if(!wrapperCustomer) return;
          
            const customerFirst = wrapperCustomer.querySelector('.customer-first');
            const customerTexts = wrapperCustomer.querySelector('.customer-texts');

            const {name, lastName} = getClientRandom;
            const firstL = getClientRandom.name;

            customerFirst.innerHTML = firstL;
            customerTexts.innerHTML = `Ha sido comprado por ${name}. ${lastName}`;

            wrapperCustomer.classList.add('active');
        })
        const Products = sortArray([...document.querySelectorAll('.product')]);

Products.forEach((product, index) => {
    var indexrand = Math.floor(Math.random() * CLIENTS.length);
  if (indexrand % 2 !== 0) {
        const getClientRandom = CLIENTS[indexrand];
        const wrapperCustomer = product.querySelector('.purchase-customer');

        if (!wrapperCustomer) return;

        const customerFirst = wrapperCustomer.querySelector('.customer-first');
        const customerTexts = wrapperCustomer.querySelector('.customer-texts');

        const { name, lastName } = getClientRandom;
        const firstL = getClientRandom.name;

        customerFirst.innerHTML = firstL;
        customerTexts.innerHTML = `Ha sido comprado por ${name}. ${lastName}`;

        wrapperCustomer.classList.add('active');
    }
});



    }, DATA_TIME);
});